import { ShieldCheck } from 'lucide-react'
import { FormattedText } from 'src/modules/core/components'
import classes from './plans-guarantee-band.module.scss'

export function PlansGuaranteeBand() {
  return (
    <section className={classes.band} data-testid="plans-guarantee-band">
      <ShieldCheck size={22} strokeWidth={1.8} className={classes.icon} aria-hidden />
      <p className={classes.text}>
        <strong>
          <FormattedText id="payment.plans.guarantee.title" />
        </strong>{' '}
        <FormattedText id="payment.plans.guarantee.text" />
      </p>
    </section>
  )
}
